<template>
  <v-container class="pa-1">
    <!-- <v-layout justify-space-between row>
      <v-flex>
        <v-card class="dashBlock elevation-3">
          <v-layout justify-space-between row>
            <v-flex>
              <p>Amount orders</p>
              <p class="numTitle">--</p>
            </v-flex>

            <v-flex>
              <p>Complete</p>
              <p style="color: green">-</p>
              <p>Cancel</p>
              <p style="color: red">-</p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock elevation-3">
          <p>Daily Promotion</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock elevation-3">
          <p>Daily Transfer</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock elevation-3">
          <p>Daily Sale</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
    </v-layout> -->

    <v-layout row>
      <v-flex>
        <v-btn
          v-if="filteredButtonSummary('order_report')"
          color="#FFD600"
          class="btnReport"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/order_report'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Order report</span>
        </v-btn>
        <v-btn
          v-if="filteredButtonSummary('promotion_report')"
          color="#FFD600"
          class="btnReport"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/promotion_report'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Promotion report</span>
        </v-btn>
        <v-btn
          v-if="filteredButtonSummary('customer_report')"
          color="#FFD600"
          class="btnReport"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/customer_report'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Customer report</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.btnReport {
  border-radius: 10px;
  margin: 0px 10px;
  height: 50px;
}
.dashBlock {
  padding: 10px;
  border-radius: 10px;
  margin: 0 10px;
  /* -webkit-box-shadow: 0 12px 20px -10px rgb(252, 255, 49),0 4px 20px 0 rgba(0,0,0,.12),0 7px 8px -5px rgba(180, 190, 26, 0.2)!important;
        box-shadow: 0 12px 20px -10px rgba(252, 255, 49, 0.28),0 4px 20px 0 rgba(0,0,0,.12),0 7px 8px -5px rgba(180, 190, 26, .2)!important; */
}

.dashBlock p {
  margin-bottom: 0px;
}

.numTitle {
  font-size: 43px;
}

.filter-sort-data {
  position: absolute;
  top: -10px;
  right: 240px;
}
</style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
  },
  methods: {
    filteredButtonSummary(value) {
      if (
        this.permission.report.summary &&
        this.permission.report.summary[value]
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
